import React, { useEffect, useState } from 'react'

import { Form, FormItem } from '@react/react-spectrum/Form'
import Heading from '@react/react-spectrum/Heading'
import Textfield from '@react/react-spectrum/Textfield'

import MediaUpload from 'components/MediaUpload'
import { useProject } from 'hooks'

import './UserContextForm.scss'

export default function UserContextForm() {
  const { project, updateProjectPart, canEdit } = useProject()
  const [userContext, setUserContext] = useState(project?.userContext || {})
  const [shouldSave, setShouldSave] = useState(false)

  useEffect(() => {
    if (userContext && shouldSave) updateProjectPart('userContext', userContext)
  }, [userContext, shouldSave])

  const onChange = (propName) => (value) => {
    setShouldSave(true)
    setUserContext((uc) => ({ ...uc, [propName]: value }))
  }

  return (
    <div className='rules-form'>
      <Form>
        <section>
          <FormItem label='Name'>
            <Textfield value={userContext.name} onChange={onChange('name')} disabled={!canEdit} />
          </FormItem>

          <FormItem label='Role'>
            <Textfield value={userContext.role} onChange={onChange('role')} disabled={!canEdit} />
          </FormItem>

          <FormItem label='Avatar'>
            <MediaUpload
              type='image'
              value={userContext.image || ''}
              maxHeight='100px'
              onUpload={onChange('image')}
              projectId={project?.meta?.id}
              path={`user-context-image`}
              withTextfield={true}
              disabled={!canEdit}
            />
          </FormItem>
        </section>
      </Form>
    </div>
  )
}
